import React from 'react'
import ModalBox from '../../components/modal/ModalBox'
import useButtonLoader from '../../hooks/UseButtonLoader'
import { toastMessage } from '../../utils/toastMessage'

import { changeTrainingStatusCategory } from '../../services/trainingManagement'

const TrainingCategoryStatus = ({ show, close, status, id, setListing }) => {
  const [buttonref, buttonLoader] = useButtonLoader('Add')

  //--------------change-status-sub-category------------------------
  const changeTrainingCategoryStatusHandler = async () => {
    try {
      buttonLoader(true)
      let sendData = { status: !status, growthTrainingCategoryId: id }
      const { data } = await changeTrainingStatusCategory(sendData)
      if (data.code === 200) {
        setListing((prevListing) => {
          return prevListing.map((category) => {
            if (category._id === id) {
              return { ...category, status: !status }
            }
            return category
          })
        })
        toastMessage(data.message, 'success', 'trainingCategoryStatus')
        close()
      } else {
        toastMessage(data.message, 'error', 'trainingCategoryStatus')
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      buttonLoader(false)
    }
  }

  return (
    <ModalBox
      status={show}
      onClose={close}
      title="Change Training Category Status"
      description="Do you want to change the status of this training category?"
      action={changeTrainingCategoryStatusHandler}
      ref={buttonref}
    />
  )
}

export default TrainingCategoryStatus
